import {action, configure, makeObservable, observable} from 'mobx';
import {storageService} from '../services/storageService';
import {_settings, Tag, _FILES} from '../configuration/index.config';
import {textInputValidation} from '../services/TextInputValidation.service';
import {request} from '../services/HttpRequestService';
import {has} from 'lodash';
import React from 'react';
import logger from '../services/AiLogger';
import stateMachine from '../services/ClientStateMachine.service';
import loadService from '../services/loadService';
import utilService from '../services/utilService';

const {DEFAULT_TIME_UPLOAD_END} = _settings.timers;

configure({enforceActions: 'never'});
interface IEdit {attributes:string[] | any[], labels:string[] | any[], classes:string[] | any[]}
export interface ISettings {
    projects: string[],
    isSessionPopUp:boolean,
    videoFilesList: string[],
    classificationProjects: {project_name : string, classes: string[]}[],
    isUploadMode: boolean,
    setSiaPage: (taskName:string, pathName:string, siaStore, accuracyObj?) => void,
    filesNotUploaded:number,
    getProjectDetails : (token:string, reqName:string, siaStore, isVideosPathApi:boolean) => Promise<any>,
    uploadProgress: number,
    isReplacePopUp: boolean,
    oldValue: string,
    uploadData: {img?:string, name?:string, json?:any} | null,
    productions: string[],
    editProjectParameters:{add: IEdit, remove:IEdit, replace:IEdit},
    isLoadingBox:boolean,
    typeToggle: string,
    colors: string | null,
    accuracyGlobalData:any,
    loadTitle: string,
    replaceValueUi: string,
    showFeatures: boolean,
    videosProjects:string[],
    taggingMode: boolean,
    replaceType: string,
    productionFeatures: any,
    productionChosenAccuracy: string,
    featuresTypes: string[],
    chosenMode: string,
    isUploadInputError: boolean,
    featuresNames:any[],
    featuresIndex: number,
    featuresTypeChosen: string,
    featuresNameChosen: string,
    projectChosen: string,
    frameSampling: number,
    productionChosen: any[],
    isLoading: boolean,
    isLoadData: boolean,
    isLabelError: boolean,
    classificationError: string,
    isClassError: boolean,
    isAttributeError: boolean,
    isErrorInputNewProject: boolean,
    newProjectInput: string,
    numberOfFiles: number,
    labelInput: string,
    classInput: string,
    failedRequest: boolean,
    labelsArray: string[],
    classesArray: string[],
    attributeInput: string,
    attributesArray: string[],
    activeViewers: number[],
    innerBoxLeft: React.RefObject<HTMLDivElement> | null,
    innerBoxCenter: React.RefObject<HTMLDivElement> | null,
    innerBoxRight: React.RefObject<HTMLDivElement> | null,
    isNewProject: boolean,
    labelError: string,
    productionFeatureChosen: string,
    attributeError: string,
    accuracyNumberOfImages: number,
    accuracyNumberOfDateNumber: number,
    accuracyNumberOfDateRange: string,
    accuracyNumberOfDate: string,
    boxHeight: string,
    activeTab:string,
    setState: (state) => void,
    pressOnNav: (typeToggle, activeTab) => void,
    findClassNameType: (value) => string,
    checkBoxOnChange: (e) => void,
    findProjectTitle: () => string,
    stopUploading:boolean,
    changeProjectOrProduction: (e) => void,
    changFeatureType : (e) => void,
    changFeatureName: (e) => void,
    calculateHeight: () => void,
    done: (siaStore) => void,
    addToAttributesArray: () => void,
    addToLabelsArray:() =>void,
    deleteFromAttributesArray: (index) => void,
    deleteFromLabelsArray: (index) => void,
    findClassDone: () => void,
    addToProductionsAccuracy: (e) => void,
    addToProductions: (e) => void,
    setProductionChosenToDefault: () => void,
    getSettingsData: (_authentication) => void,
    setInnerBoxes: (innerBoxLeft, innerBoxCenter, innerBoxRight) => void,
    closeUploadPopUp: (siaStore) => void,
    closeReplacePopUp: () => void,
    isLoadingClassification: boolean,
    indexClass:number
}

export class SettingsStore implements ISettings {
    @observable projects = observable([]);
    @observable indexClass = -1;
    @observable activeTab = 'Image Tagging';
    @observable filesNotUploaded = 0;
    @observable videoFilesList:string[] = observable([]);
    @observable isSessionPopUp = true;
    @observable classificationProjects: {project_name : string, classes: string[], files: any}[] = observable([]);
    @observable productions = observable([]);
    @observable videosProjects = observable([]);
    @observable classificationError = '';
    @observable isLoadingClassification = true;
    @observable isUploadMode = false;
    @observable stopUploading = false;
    @observable isReplacePopUp = false;
    @observable colors = null;
    @observable replaceType = '';
    @observable isLoadingBox = false;
    @observable uploadData = {img: '', name: '', json: {}};
    @observable uploadProgress = 0;
    @observable typeToggle = Tag.DEFAULT;
    @observable numberOfFiles = 0;
    @observable accuracyGlobalData = {};
    @observable editProjectParameters:any = {
        add: {attributes: [], labels: [], classes: []},
        remove: {attributes: [], labels: [], classes: []},
        replace: {attributes: [], labels: [], classes: []}
    }
    @observable loadTitle = 'Upload Images';
    @observable productionFeatureChosen = '';
    @observable replaceValueUi = '';
    @observable oldValue = '';
    @observable isNewProject = false;
    @observable showFeatures = false;
    @observable productionFeatures = null;
    @observable isUploadInputError = false;
    @observable failedRequest = false;
    @observable frameSampling = 10;
    @observable accuracyNumberOfImages = 1;
    @observable accuracyNumberOfDateRange = 'days'
    @observable accuracyNumberOfDateNumber = 1;
    @observable accuracyNumberOfDate = '/'
    @observable productionChosenAccuracy = ''
    @observable chosenMode = 'Tracker'
    @observable taggingMode = true;
    @observable featuresIndex = 0;
    @observable featuresTypes = observable([]);
    @observable featuresNames = observable([]);
    @observable labelsArray: any[] = observable([]);
    @observable classesArray: any[] = observable([]);
    @observable attributesArray: any[] = observable([]);
    @observable featuresTypeChosen = '';
    @observable featuresNameChosen = '';
    @observable newProjectInput = '';
    @observable projectChosen = '';
    @observable activeViewers: number[] = observable([]);
    @observable productionChosen: any[] = observable([]);
    @observable isLoading = true;
    @observable isLoadData = false;
    @observable isErrorInputNewProject = false;
    @observable isLabelError = false;
    @observable isClassError = false;
    @observable isAttributeError = false;
    @observable labelInput = '';
    @observable classInput = '';
    @observable attributeInput = '';
    @observable labelError = '';
    @observable attributeError = '';
    @observable boxHeight = '';
    @observable innerBoxLeft:React.RefObject<HTMLDivElement> | null = null;
    @observable innerBoxRight:React.RefObject<HTMLDivElement> | null = null;
    @observable innerBoxCenter:React.RefObject<HTMLDivElement> | null = null;

    constructor() {
        makeObservable(this, {
            isLoading: observable,
            videoFilesList: observable,
            isSessionPopUp: observable,
            activeTab: observable,
            indexClass: observable,
            loadTitle: observable,
            isLoadingClassification: observable,
            accuracyGlobalData: observable,
            videosProjects: observable,
            stopUploading: observable,
            filesNotUploaded: observable,
            editProjectParameters: observable,
            productionFeatureChosen: observable,
            failedRequest: observable,
            classificationError: observable,
            uploadProgress: observable,
            replaceValueUi: observable,
            productionFeatures: observable,
            isUploadMode: observable,
            typeToggle: observable,
            isReplacePopUp: observable,
            replaceType: observable,
            taggingMode: observable,
            isLoadingBox: observable,
            showFeatures: observable,
            isLabelError: observable,
            isClassError: observable,
            featuresIndex: observable,
            oldValue: observable,
            isUploadInputError: observable,
            isAttributeError: observable,
            featuresTypeChosen: observable,
            productionChosenAccuracy: observable,
            featuresNameChosen: observable,
            projectChosen: observable,
            productionChosen: observable,
            chosenMode: observable,
            frameSampling: observable,
            isLoadData: observable,
            labelInput: observable,
            classInput: observable,
            activeViewers: observable,
            attributeInput: observable,
            classificationProjects: observable,
            colors: observable,
            boxHeight: observable,
            attributesArray: observable,
            accuracyNumberOfImages: observable,
            accuracyNumberOfDateRange: observable,
            accuracyNumberOfDateNumber: observable,
            accuracyNumberOfDate: observable,
            labelsArray: observable,
            classesArray: observable,
            isNewProject: observable,
            numberOfFiles: observable,
            newProjectInput: observable,
            isErrorInputNewProject: observable,
            innerBoxLeft: observable,
            innerBoxCenter: observable,
            innerBoxRight: observable
        });
    }

    setLoadTitle = (loadTitle) => this.loadTitle = loadTitle;

    findMode = (_authentication) => {
        let mode = this.typeToggle;

        if (!_authentication.tagging) {
            mode = _authentication.classification ? Tag.SEGMENTHOR : Tag.LISTEN;
        }

        return mode;
    }
    @action setClassProjectOnSelect = async () => {
        this.classesArray.splice(0, this.classesArray.length);
        this.videoFilesList.splice(0, this.videoFilesList.length);
        this.numberOfFiles = 0;
        loadService.setUploadImages();
        await stateMachine.setStoreOrServiceData([{serviceName: 'settingsStore', newData: {isNewProject: this.isNewProject, classesArray: [], numberOfFiles: 0}}]);
    }
    @action calculateNumberOfFiles = (project) => {
        let number = 0;

        project.files && Object.values(project.files).forEach((fileArr:any) => number += fileArr.length);

        return number;
    }
    @action findNumberOfFiles = (project) => Object.values(project.files).forEach((fileArr:any) => this.numberOfFiles += fileArr.length);
    @action getClassificationProjects = async () => {
        const token = storageService.loadFromStorage('token');

        try {
            const res = await request.get(token, 'PROJECT_LIST', false, '', true);

            if ('projects' in res.data) {
                res.data.recommended_images_per_class && (_FILES.VIDEO.RED_LINE = res.data.recommended_images_per_class);
                res.data.min_images_per_class && (_FILES.VIDEO.BLACK_LINE = res.data.min_images_per_class);
                _FILES.VIDEO.MAX_SIZE = res.data.max_videos_size;
                this.classificationProjects = res.data.projects;

                if (!this.classificationProjects.some((project) => this.calculateNumberOfFiles(project) > 0)) {
                    await this.setState({isLoading: false, isNewProject: true, isLoadingClassification: false});

                    return;
                }
                const firstProject = this.classificationProjects.find((project) => this.calculateNumberOfFiles(project) > 0);

                if (firstProject) {
                    this.projectChosen = firstProject.project_name;
                    this.classesArray = [...firstProject.classes];
                    this.findNumberOfFiles(firstProject);
                    this.isLoadingClassification = false;
                }
            }


        } catch (error) {
            JSON.stringify(error) !== '{}' ? (this.failedRequest = true) : await this.setState({isLoading: false, isNewProject: true, isLoadingClassification: false});
            console.error(JSON.stringify(error));
        }


    }

    /**
     * getSettingsData - get settings data from server
     */
    @action getSettingsData = (_authentication) => {
        const token = storageService.loadFromStorage('token');

        request.get(token, 'GET_SETTINGS', false, '').then((res) => {
            const videosProjects = res.data.video_tagging_projects;
            const features = res.data.ai_features;
            let indexProjectChosen = 0;
            const featuresTypes: string[] = [];
            const accuracyGlobalData = {};
            let productionChosenAccuracy = '';
            let productionFeatureChosen = '';
            const featuresNames: any[] = [];
            const productionFeatures: any = {};
            const projects = _authentication.imagesTagging ? res.data.tagging_projects.filter((value) => value !== '') : '';
            const projectChosen = this.projectChosen || projects[0];
            const productionFeaturesTemp = res.data.production_features;
            const productions = res.data.production_projects;
            const activeViewers = res.data.active_viewers;

            for (const key in productionFeaturesTemp) {
                if (has(productionFeaturesTemp, key)) {
                    const featuresValues = Object.keys(productionFeaturesTemp[key]);

                    for (const innerKey in productionFeaturesTemp[key]) {
                        if (has(productionFeaturesTemp[key], innerKey)) {
                            accuracyGlobalData[innerKey] = productionFeaturesTemp[key][innerKey];
                        }
                    }
                    productionFeatures[key] = featuresValues;
                    if (indexProjectChosen === 0) {
                        productionChosenAccuracy = key;
                        productionFeatureChosen = featuresValues[0];
                    }
                    indexProjectChosen++;
                }
            }
            for (const key in features) {
                if (has(features, key)) {
                    featuresTypes.push(key);
                    featuresNames.push(features[key]);
                }
            }

            projectChosen ? this.changeProjectOrProduction(projectChosen, () => {
                this.setState({
                    featuresTypes,
                    featuresNames,
                    videosProjects,
                    accuracyGlobalData,
                    productionFeatures,
                    productionFeatureChosen,
                    productionChosenAccuracy,
                    featuresTypeChosen: featuresTypes[0],
                    featuresNameChosen: featuresNames[0] ? featuresNames[0][0] : '',
                    projects,
                    activeViewers,
                    projectChosen,
                    productions,
                    typeToggle: this.findMode(_authentication),
                    isNewProject: this.projects.length === 0,
                    isLoading: false
                });
            }, true) : this.setState({
                featuresTypes,
                featuresNames,
                videosProjects,
                accuracyGlobalData,
                productionFeatures,
                productionFeatureChosen,
                productionChosenAccuracy,
                featuresTypeChosen: featuresTypes[0],
                featuresNameChosen: featuresNames[0][0],
                projects,
                activeViewers,
                projectChosen,
                isNewProject: this.projects.length === 0,
                productions,
                typeToggle: this.findMode(_authentication),
                isLoading: false
            });
        }).catch((error) => {
            JSON.stringify(error) !== '{}' ? (this.failedRequest = true) : this.setState({isLoading: false, isNewProject: true});
            console.error(JSON.stringify(error));
        });
    }

    /**
     * setInnerBoxes - get boxes refs
     * @param innerBoxLeft - ref
     * @param innerBoxRight - ref
     * @param innerBoxCenter - ref
     */
    @action setInnerBoxes = (innerBoxLeft, innerBoxCenter, innerBoxRight) => {
        this.innerBoxLeft = innerBoxLeft;
        this.innerBoxCenter = innerBoxCenter;
        this.innerBoxRight = innerBoxRight;
    }

    setUploadPopUpBasicParams = () => {
        this.newProjectInput = '';
        this.stopUploading = false;
        this.isUploadMode = false;
        this.loadTitle = 'Upload Images';
    }

    openClassificationWs = (siaStore) => siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => {});

    /**
     * openClassificationProject - ask for classification data from server
     * @param siaStore  - ref for siaStore
     */
    openClassificationProject = async (siaStore) => {
        const projectName = this.isNewProject ? this.newProjectInput : this.projectChosen;
        const res = await request.get(storageService.loadFromStorage('token'), 'CLASSIFICATION_GET_PROJECT', false, projectName, true);

        if (res.data) {
            siaStore.setClasses(res.data.classes);
            siaStore.setClassName(res.data.classes[0]);
            siaStore.setProjectName(res.data.project_name);
            siaStore.setMode(this.typeToggle);
            siaStore.setLoadTitleRef(this.setLoadTitle);
            siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('open_train_project'));
            await stateMachine.setStoreOrServiceData([
                {
                    serviceName: 'settingsStore',
                    newData: {
                        func: 'openClassificationProject',
                        funcArg: ['siaStore'],
                        isUploadMode: true,
                        loadTitle: 'Open project',
                        stopUploading: true,
                        numberOfFiles: this.numberOfFiles}
                },
                {
                    serviceName: 'siaStore',
                    newData: {
                        classes: res.data.classes,
                        className: res.data.classes[0],
                        projectName: res.data.project_name,
                        mode: this.typeToggle
                    }
                }
            ]);
        }
    }

    /**
     * createAndOpenClassificationProject - Create and open classification project
     * @param siaStore - ref for siaStore
     */
    createAndOpenClassificationProject = async (siaStore) => {
        const token = storageService.loadFromStorage('token');

        try {
            await this.sendProjectDetailsToServer(token, 'PROJECT_DETAILS_CLASSIFICATION', false, true);
            await logger.sendLog(`user ${storageService.loadFromStorage('username')} created project ${this.newProjectInput} in classification`);
            await this.openClassificationProject(siaStore);
            await logger.sendLog(`user ${storageService.loadFromStorage('username')} open project ${this.newProjectInput} in classification`);
        } catch (e) {
            await logger.sendLog(`error in project ${this.newProjectInput} sending project classification`, e, 'error');
        }
    }

    /**
     * sendProjectDetailsToServer - send new project data to server
     * @param token - user token
     * @param reqName - the request name
     * @param isVideosPathApi - find if in video api
     * @param isClassification - find if in classification api
     */
     sendProjectDetailsToServer = async (token, reqName = 'PROJECT_DETAILS', isVideosPathApi = false, isClassification = false) => {
         const classificationProject = this.isNewProject ? this.newProjectInput : this.projectChosen;

         await request.post(token, reqName, {
             'project_name': (this.typeToggle === Tag.SEGMENTHOR && reqName === 'PROJECT_DETAILS') ? `${this.newProjectInput}_VideoTagging` : classificationProject,
             labels: this.labelsArray,
             attributes: this.attributesArray,
             classes: this.classesArray,
             'user_name': storageService.loadFromStorage('username')
         }, isVideosPathApi, isClassification);
     }

    /**
     * getProjectDetails - get user project details
     * @param token
     * @param siaStore
     * @param reqName - the request name
     * @param isVideosPathApi - video as different path
     */
    getProjectDetails = (token, reqName, siaStore, isVideosPathApi) => new Promise<any>((resolve, reject) => {
        if (this.projectChosen) {
            request.get(token, reqName, isVideosPathApi, this.projectChosen).then((res) => {
                if (siaStore) {
                    this.colors = res.data.colors;
                    siaStore.setColorDefault(res.data.colors);
                    siaStore.setChosenAttribute(res.data.attributes[0]);
                    siaStore.setChosenLabel(res.data.labels[0]);
                    siaStore.addToDefaultAttributes(res.data.attributes);
                    siaStore.addToDefaultLabels(res.data.labels);
                    if (this.typeToggle === Tag.DEBUG) {
                        siaStore.setClasses(res.data.classes);
                        siaStore.setClassName(res.data.classes[0]);
                    }
                } else {
                    this.isLoadingBox = !this.isNewProject && res.data.project_name === this.projectChosen;
                    const attributesArray = this.isLoadingBox ? res.data.attributes || [] : [];
                    const labelsArray = this.isLoadingBox ? res.data.labels || [] : [];
                    const classesArray = this.isLoadingBox ? res.data.classes || [] : [];

                    this.setState({attributesArray, labelsArray, classesArray});
                }
                resolve('');
            }).catch((error) => {
                this.isLoadingBox = false;
                console.error(error);
                reject(error);
            });
        } else {
            resolve('');
        }
    })

    /**
     * setAutoTagging - when user choose AutoTagging mode
     */
    setAutoTagging = (siaStore) => {
        if (this.showFeatures && this.typeToggle === Tag.DEFAULT) {
            siaStore.setPageAfterUploadSia(this.setPageAfterUpload);
            siaStore.setProgressBarAfterUploadSia(this.setProgressBarAfterUpload);
            storageService.saveToStorage('autoTagging', {
                featuresTypeChosen: this.featuresTypeChosen,
                featuresNameChosen: this.featuresNameChosen,
            });
        }
    }

    /**
     * setState - set mobx state
     * @param state - new state
     */
    @action setState = async (state) => {
        for (const key in state) {
            if (key in this) {
                this[key] = state[key];
            }
        }
    }

    /**
     * setProductionChosenToDefault - set Production Chosen To Default
     */
    @action setProductionChosenToDefault = () => this.productionChosen.splice(0, this.productionChosen.length);

    /**
     * pressOnNav - press on navigation
     */
    @action pressOnNav = async (typeToggle, activeTab) => {
        this.typeToggle = typeToggle;
        this.activeTab = activeTab;
        this.taggingMode = true;
        this.isNewProject = false;
        this.isLabelError = false;
        this.isClassError = false;
        this.isAttributeError = false;
        this.labelsArray.splice(0, this.labelsArray.length);
        this.attributesArray.splice(0, this.attributesArray.length);
        this.classesArray.splice(0, this.classesArray.length);
        this.newProjectInput = '';
        this.isErrorInputNewProject = false;
        this.isUploadInputError = false;
        this.attributeInput = '';
        this.labelInput = '';
        this.classInput = '';
        this.boxHeight = '50px';
        this.replaceType = '';
        this.isReplacePopUp = false;
        this.replaceValueUi = '';
        this.oldValue = '';
        if (typeToggle === Tag.SEGMENTHOR) {
            this.changeProjectOrProduction(this.videosProjects[0]);
        } else if (typeToggle === Tag.DEFAULT) {
            this.changeProjectOrProduction(this.projects[0]);
        }
        await stateMachine.setStoreOrServiceData([{serviceName: 'settingsStore', newData: {typeToggle: this.typeToggle}}]);
    };

    /**
     * openReplace - open Replace popup
     * @param value - the old value of the attribute/ label/ class
     * @param type attribute/ label/ class
     */
    @action openReplace = (value, type) => {
        this.isReplacePopUp = true;
        this.replaceValueUi = value;
        this.replaceType = type;
        this.oldValue = value;
    }

    /**
     * closeReplacePopUp - close replace popup
     */
    @action closeReplacePopUp = () => {
        if (textInputValidation.checkValidValueRegex(this.replaceValueUi, 'PROJECT_NAME_REGEX') && this.replaceValueUi !== this.oldValue && this[`${this.replaceType}Array`].findIndex((value) => value === this.replaceValueUi) === -1) {
            const findIndex = this[`${this.replaceType}Array`].findIndex((value) => value === this.oldValue);
            const editProjectParametersCopy = [...this.editProjectParameters.replace[this.replaceType], {new: this.replaceValueUi, old: this.oldValue}];
            const arrayCopy = [...this[`${this.replaceType}Array`]];

            arrayCopy.splice(findIndex, 1, this.replaceValueUi);
            this[`${this.replaceType}Array`] = [...arrayCopy];
            this.editProjectParameters.replace[this.replaceType] = [...new Set(editProjectParametersCopy)];
        }
        this.isReplacePopUp = false;
        this.replaceValueUi = '';
        this.replaceType = '';
        this.oldValue = '';
    }

    /**
     * findClassNameType - toggle effect by the type Toggle
     */
    @action findClassNameType = (value) => (value === this.typeToggle ? 'setting-toggle-inner-active' : 'setting-toggle-inner-unActive');

    /**
     * checkBoxOnChange - if user press on check box (auto tagging)
     */
    @action checkBoxOnChange = (e) => this.showFeatures = e.target.checked;

    /**
     * findProjectTitle - title toggle by 'typeToggle'
     */
    @action findProjectTitle = () => (this.typeToggle === Tag.DEFAULT || this.typeToggle === Tag.SEGMENTHOR ? 'Project Name' : 'Production')

    /**
     * changeProjectOrProduction - when user select project/production
     * @param projectNameValue - value string
     * @param setStateAsync - setState after change
     * @param isFromStart - check if the function called from start stage
     */
    @action changeProjectOrProduction = async (projectNameValue, setStateAsync = () => {}, isFromStart = false) => {
        this.projectChosen = projectNameValue;
        const checkInput = this.typeToggle === Tag.SEGMENTHOR ? (this.videosProjects.findIndex((value) => value === projectNameValue) === -1 && !isFromStart) : (this.projects.findIndex((value) => value === projectNameValue) === -1 && !isFromStart);

        await stateMachine.setStoreOrServiceData([{serviceName: 'settingsStore', newData: {typeToggle: this.typeToggle, projectChosen: this.projectChosen, isNewProject: this.isNewProject}}]);
        if (checkInput) {
            return;
        }

        const token = storageService.loadFromStorage('token');
        const isVideosPathApi = this.typeToggle === Tag.SEGMENTHOR;
        const reqName = isVideosPathApi ? 'PROJECT_DETAILS_VIDEOS' : 'PROJECT_DETAILS';

        this.isAttributeError = false;
        this.isClassError = false;
        this.isLabelError = false;
        this.isLoadingBox = true;

        if (this.typeToggle !== Tag.LISTEN) {
            reqName && this.getProjectDetails(token, reqName, null, isVideosPathApi).then(() => {
                this.isLoadingBox = false;
                this.calculateHeight();
                setStateAsync();
            }).catch((e) => {
                logger.sendLog('error in get project details : ', e, 'error');
                setStateAsync();
            });
        } else {
            this.isLoadingBox = false;
            this.calculateHeight();
            setStateAsync();
        }
    };

    /**
     * changFeatureType - chang feature type
     */
    @action changFeatureType = (e) => {
        this.featuresTypeChosen = e.target.value;
        this.featuresIndex = this.featuresTypes.findIndex((value) => value === e.target.value);
        this.featuresNameChosen = this.featuresNames[this.featuresIndex][0];
    }

    /**
     * changFeatureName - chang feature name
     */
    @action changFeatureName = (e) => this.featuresNameChosen = e.target.value;

    /**
     * calculateHeight - calculate Height of box container (for sibling top)
     */
    @action calculateHeight = () => {
        if (this!.innerBoxRight && this.innerBoxLeft && this.innerBoxCenter) {
            const boxHeight = Math.max(this.innerBoxRight!.current!.clientHeight, this.innerBoxCenter.current!.clientHeight, this.innerBoxLeft!.current!.clientHeight);

            this.boxHeight = `${boxHeight + 50}px`;

            return this.boxHeight;
        }
    };

    /**
     * addToAttributesArray - add To Attributes Array
     */
    addToAttributesArray = () => {
        if (textInputValidation.checkValidValueRegex(this.attributeInput, 'META_NAME_REGEX')) {
            const attributesArrayCopy = [...this.attributesArray, this.attributeInput];
            const editProjectParametersCopy = [...this.editProjectParameters.add.attributes, this.attributeInput];

            this.attributesArray = [...new Set(attributesArrayCopy)];
            this.editProjectParameters.add.attributes = [...new Set(editProjectParametersCopy)];
            this.attributeInput = '';
            this.isAttributeError = false;
        }

    }

    /**
     * addToClassArray - add to Labels Array
     */
    addToClassArray = async () => {
        if (textInputValidation.checkValidValueRegex(this.classInput, 'META_NAME_REGEX')) {
            const classesArrayArrayCopy = [...this.classesArray, this.classInput];
            const editProjectParametersCopy = [...this.editProjectParameters.add.classes, this.classInput];

            this.classesArray = [...new Set(classesArrayArrayCopy)];
            this.editProjectParameters.add.classes = [...new Set(editProjectParametersCopy)];
            this.classInput = '';
            this.isClassError = false;
            await stateMachine.setStoreOrServiceData([{serviceName: 'settingsStore', newData: {classesArray: this.classesArray, editProjectParameters: this.editProjectParameters, classInput: this.classInput, isClassError: this.isClassError}}]);
        }
    }

    /**
     * addToLabelsArray - add to Labels Array
     */
    addToLabelsArray = () => {
        if (textInputValidation.checkValidValueRegex(this.labelInput, 'META_NAME_REGEX')) {
            const labelsArrayArrayCopy = [...this.labelsArray, this.labelInput];
            const editProjectParametersCopy = [...this.editProjectParameters.add.labels, this.labelInput];

            this.labelsArray = [...new Set(labelsArrayArrayCopy)];
            this.editProjectParameters.add.labels = [...new Set(editProjectParametersCopy)];
            this.labelInput = '';
            this.isLabelError = false;
        }
    }

    /**
     * deleteFromEditParameters - if need to delete from edit object
     * @param value - the value we want to check on
     * @param type - attributes/ labels/ classes
     */
    deleteFromEditParameters = (value, type) => {
        const addIndex = this.editProjectParameters.add[type].findIndex((param) => param === value);

        if (addIndex > -1) {
            this.editProjectParameters.add[type].splice(addIndex);
        } else {
            const editProjectParametersCopy = [...this.editProjectParameters.remove[type], value];

            this.editProjectParameters.remove[type] = [...new Set(editProjectParametersCopy)];
        }
    }

    /**
     * deleteFromClassesArray - delete From labels Array
     * @param index - index to delete
     */
    deleteFromClassesArray = async (index) => {
        const classesArrayArrayCopy = [...this.classesArray];

        if (this.typeToggle === Tag.CLASSIFICATION) {
            const numberOfFiles = loadService.deleteVideoByFOlderName(this.classesArray[index]);

            this.numberOfFiles -= numberOfFiles;
        }
        this.deleteFromEditParameters(classesArrayArrayCopy[index], 'classes');
        classesArrayArrayCopy.splice(index, 1);
        this.classesArray = [...classesArrayArrayCopy];
        this.calculateHeight();
        await stateMachine.setStoreOrServiceData([{serviceName: 'settingsStore', newData: {classesArray: this.classesArray}}]);

    }

    /**
     * deleteFromLabelsArray - delete From labels Array
     * @param index - index to delete
     */
    deleteFromLabelsArray = (index) => {
        const labelsArrayArrayCopy = [...this.labelsArray];

        this.deleteFromEditParameters(labelsArrayArrayCopy[index], 'labels');
        labelsArrayArrayCopy.splice(index, 1);
        this.labelsArray = [...labelsArrayArrayCopy];
        this.calculateHeight();
    }

    /**
     * addToProductionsAccuracy - when user choose production checkbox to add to verification - accuracy mode
     * @param e
     */
    addToProductionsAccuracy = (e) => {
        this.productionChosenAccuracy = e.target.value;
        // @ts-ignore
        this.productionFeatureChosen = this.productionFeatures[this.productionChosenAccuracy][0];
    }

    /**
     * addToProductions - when user choose production checkbox to add to verification mode
     * @param e - event click
     */
    addToProductions = (e) => {
        if (e.target.checked) {
            const copy = [...this.productionChosen, e.target.value];

            this.productionChosen = [...new Set(copy)];
        } else {
            const index = this.productionChosen.findIndex((value) => value === e.target.value);

            this.productionChosen.splice(index, index + 1);
        }
    }

    /**
     * deleteFromAttributesArray - delete From Attributes Array
     * @param index - index to delete
     */
    deleteFromAttributesArray = (index) => {
        const attributesArrayCopy = [...this.attributesArray];

        this.deleteFromEditParameters(attributesArrayCopy[index], 'attributes');
        attributesArrayCopy.splice(index, 1);
        this.attributesArray = [...attributesArrayCopy];
        this.calculateHeight();

    }

    /**
     * findClassDone - find class done
     */
    // @ts-ignore
    findClassDone = () => {
        const colorBtn = this.isLoadingBox ? 'btn-disabled' : 'btn-main';

        return `${colorBtn} setting-project-done ${!this.isNewProject && this.typeToggle === Tag.DEFAULT ? 'top-md' : 'top-xl'}`;
    }

    /**
     * setSiaPage - set sia page according user input
     * @param taskName - taskName to websocket
     * @param pathName - path name to websocket
     * @param siaStore - siaStore singleton
     * @param accuracyObj - if accuracy object exist
     */
    setSiaPage = (taskName, pathName, siaStore, accuracyObj = {}) => {
        this.labelsArray.length > 0 && siaStore.addToDefaultLabels(this.labelsArray);
        this.attributesArray.length > 0 && siaStore.addToDefaultAttributes(this.attributesArray);
        this.classesArray.length > 0 && siaStore.setClasses(this.classesArray);
        siaStore.setProjectName(pathName);
        siaStore.setMode(this.typeToggle);
        this.setState({isLoadData: true});
        siaStore.setLabelList();
        siaStore.setAttributeList();
        siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore!.sendTask(taskName, this.featuresTypeChosen, this.featuresNameChosen));
        storageService.saveToStorage('refresh', {
            labelsArray: siaStore.labelList,
            attributesArray: siaStore.attributeList,
            classesArray: siaStore.classes,
            pathName,
            taskName,
            accuracyObj,
            frameSampling: this.frameSampling,
            colors: this.colors,
            typeToggle: this.typeToggle,
            featuresTypeChosen: this.featuresTypeChosen,
            featuresNameChosen: this.featuresNameChosen
        });
    }

    setVideoName = (video) => (this.typeToggle === Tag.CLASSIFICATION ? `${video.folderName}_${video.name}` : `${video.name}`);

    /**
     * sendVideosToS3 - send videos to s3 (segmenthor mode)
     * @param siaStore - siaStore instance
     * @param i - index of file
     */
    sendVideosToS3 = async (siaStore, i = 0) => {
        const token = storageService.loadFromStorage('token');

        if (i === loadService.videosFiles.length) {
            if (this.filesNotUploaded === loadService.videosFiles.length) {
                this.uploadProgress = 100;
                this.stopUploading = true;
                this.loadTitle = 'Failed to upload project';
                this.filesNotUploaded = 0;

                return;
            } else if (this.typeToggle !== Tag.CLASSIFICATION) {
                try {
                    await Promise.all([this.sendProjectDetailsToServer(token, 'PROJECT_DETAILS_VIDEOS', true), this.sendProjectDetailsToServer(token)]);

                } catch (e) {
                    await logger.sendLog('error in upload project video to DB : ', e, 'error');
                }
            }
            this.uploadProgress = 100;
            this.filesNotUploaded = 0;
            setTimeout(() => {
                !(this.typeToggle === Tag.CLASSIFICATION) && this.pressOnNav(Tag.DEFAULT, 'Image Tagging');
                this.setPageAfterUpload(siaStore);
            }, DEFAULT_TIME_UPLOAD_END);

            return;
        }
        loadService.videosFiles[i].name = this.setVideoName(loadService.videosFiles[i]);
        let projectName = this.newProjectInput;

        if (this.typeToggle === Tag.CLASSIFICATION) {
            projectName = this.isNewProject ? this.newProjectInput : this.projectChosen;
        }

        request.sendVideoToS3(loadService.videosFiles[i], projectName, this.typeToggle === Tag.CLASSIFICATION).then(() => {
            logger.sendLog(`user ${storageService.loadFromStorage('username')} uploaded video ${loadService.videosFiles[i].name}`);
            this.uploadProgress = parseInt(`${((i + 1) / loadService.videosFiles.length) * 100}`, 10);
            this.sendVideosToS3(siaStore, i + 1);
        }).catch((error) => {
            logger.sendLog(`user ${storageService.loadFromStorage('username')} error uploaded video ${loadService.videosFiles[i].name}`, [error]);
            this.filesNotUploaded++;
            this.sendVideosToS3(siaStore, i + 1);
        });

    }

    /**
     * closeUploadPopUp - close upload popup
     * @param siaStore - siaStore instance
     */
    @action closeUploadPopUp = (siaStore) => {
        if (this.loadTitle === 'Upload Images' && !siaStore.ws.isActive) {
            if (this.newProjectInput && textInputValidation.checkValidValueRegex(this.newProjectInput, 'PROJECT_NAME_REGEX')) {
                this.stopUploading = true;
                siaStore.setPageAfterUploadSia(this.setPageAfterUpload);
                siaStore.setProjectName(this.newProjectInput);
                setTimeout(() => {
                    siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('delete_project'));
                }, 2000);
            } else if (!this.newProjectInput && textInputValidation.checkValidValueRegex(this.projectChosen, 'PROJECT_NAME_REGEX')) {
                this.stopUploading = true;
                siaStore.setPageAfterUploadSia(this.setPageAfterUpload);
                siaStore.setProjectName(this.projectChosen);
                setTimeout(() => {
                    siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('delete_multiple_images_s3'));
                }, 2000);
            }

        } else {
            if (this.filesNotUploaded === loadService.videosFiles.length && this.typeToggle === Tag.CLASSIFICATION) {
                this.isUploadMode = false;
                this.uploadProgress = 0;
                this.stopUploading = false;
                this.loadTitle = 'Upload Videos';

                return;
            }
            siaStore.sendTask('cancel_task');
            this.setPageAfterUpload(siaStore);
        }
    }

    /**
     * setPageAfterUpload - after upload ends
     */
    setPageAfterUpload = async (siaStore) => {
        if (this.loadTitle === 'Upload Images' || this.loadTitle === 'Load autoTagging' || (this.loadTitle === 'Upload Videos' && this.typeToggle === Tag.SEGMENTHOR)) {
            location.reload();

            return;
        }
        this.uploadData = {img: '', name: '', json: {}};
        this.uploadProgress = 0;
        loadService.setUploadImages();
        storageService.removeFromStorage('autoTagging');
        storageService.removeFromStorage('taskId');
        siaStore.ws.closeConnection();
        if ((this.loadTitle === 'Upload Videos' || this.loadTitle === 'Open existing project') && this.typeToggle === Tag.CLASSIFICATION) {
            this.stopUploading = true;
            this.loadTitle = 'Open project';
            await this.createAndOpenClassificationProject(siaStore);

            return;
        }
        this.setUploadPopUpBasicParams();
    }

    /**
     * setProgressBarAfterUpload - set Progress Bar After Upload
     * @param jumpIn - if total need to jump in
     * @param index - the image
     * @param imageUploadList - find if process over
     * @param siaStore - siaStore instance
     * @param projectName - the project name
     * @param downloadTotal - if download : the total of all download data
     */
    setProgressBarAfterUpload = (jumpIn, index, imageUploadList = [], siaStore = null, projectName = '', downloadTotal = -1) => {
        const total = downloadTotal > 0 ? downloadTotal : this.numberOfFiles;

        this.uploadProgress = parseInt(`${(index / (total / jumpIn)) * 100}`, 10);
        this.uploadProgress === 100 && (this.stopUploading = true);
        if (imageUploadList.length > 0) {
            imageUploadList.splice(0, 1);
            this.startUploadingImages(siaStore, projectName, index + 1);
        }
    }

    /**
     * startUploadingImages - start upload process (this is Recursion!!!!!)
     * @param projectName - project Name
     * @param index - list index
     * @param siaStore - siaStore instance
     */
    startUploadingImages = (siaStore, projectName, index = 0) => {
        if (this.stopUploading) {
            return;
        }
        if (textInputValidation.checkValidValueRegex(projectName, 'PROJECT_NAME_REGEX')) {
            const imageUploadList = loadService.imageUploadArray;
            const autoTagData = storageService.loadFromStorage('autoTagging');
            const token = storageService.loadFromStorage('token');

            this.isUploadMode = true;
            const dataToUpload = imageUploadList[0];

            if (!dataToUpload) {
                this.sendProjectDetailsToServer(token);
                this.uploadProgress = 100;

                setTimeout(() => {
                    if (autoTagData) {
                        this.uploadProgress = 0;
                        this.loadTitle = 'Load autoTagging';
                        siaStore.setProjectName(projectName);
                        siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('annotate_project', autoTagData.featuresTypeChosen, autoTagData.featuresNameChosen));
                    } else {
                        this.setPageAfterUpload(siaStore);
                    }
                }, DEFAULT_TIME_UPLOAD_END);

                return;
            }
            loadService.getDataFromFolder({}, dataToUpload).then((loadImageData) => {
                this.uploadData.name = imageUploadList[0][Object.keys(imageUploadList[0])[0]].name;
                this.uploadData.img = loadImageData[0].img.src;
                if (loadImageData[0].imageObject) {
                    this.uploadData.json = {annotations: JSON.parse(JSON.stringify(loadImageData[0].imageObject.annotations))};
                    request.sendJsonsToS3({name: `${this.uploadData.name.split('.')[0]}.json`, data: this.uploadData.json}, projectName).then(() => {
                        !this.stopUploading && request.sendImagesToS3(this.uploadData, projectName).then(() => {
                            !this.stopUploading && this.setProgressBarAfterUpload(2, index, imageUploadList, siaStore, projectName);
                        }).catch((error) => {
                            logger.sendLog(`error upload Image ${this.uploadData.name}`, error, 'error');
                            !this.stopUploading && this.setProgressBarAfterUpload(2, index, imageUploadList, siaStore, projectName);
                        });
                    }).catch((error) => {
                        logger.sendLog(`error upload Json ${this.uploadData.name}`, error, 'error');
                        !this.stopUploading && this.setProgressBarAfterUpload(2, index, imageUploadList, siaStore, projectName);
                    });
                } else {
                    !this.stopUploading && request.sendImagesToS3(this.uploadData, projectName).then(() => {
                        this.setProgressBarAfterUpload(1, index, imageUploadList, siaStore, projectName);
                    }).catch((error) => {
                        logger.sendLog(`error upload Image ${this.uploadData.name}`, error, 'error');
                        !this.stopUploading && this.setProgressBarAfterUpload(1, index, imageUploadList, siaStore, projectName);
                    });
                }
            });
        } else {
            this.isErrorInputNewProject = true;
        }

    }

    checkFolders = (foldersNames, classNames) => {
        const [folderExist, classExist] = [{isFolderExist: true, folderName: ''}, {isClassExist: true, className: ''}];

        const isFolderExists = (folder) => {
            if (!(classNames.includes(folder))) {
                folderExist.isFolderExist = false;
                folderExist.folderName = folder;

                return false;
            }

            return true;
        };

        const isClassExists = (classN) => {
            if (!(foldersNames.includes(classN))) {
                classExist.isClassExist = false;
                classExist.className = classN;

                return false;
            }

            return true;
        };

        foldersNames.every(isFolderExists);
        classNames.every(isClassExists);

        return [folderExist, classExist];
    }
    @action uploadVideosToExistingProject = (siaStore) => {
        this.videoFilesList.splice(0, this.videoFilesList.length);
        this.isUploadMode = true;
        this.loadTitle = loadService.videosFiles.length === 0 ? 'Open existing project' : 'Upload Videos';
        loadService.videosFiles.length === 0 ? this.setPageAfterUpload(siaStore) : this.sendVideosToS3(siaStore);
    }

    /**
     * createNewProject - create new project
     * @param siaStore - siaStore singleton
     */
    // eslint-disable-next-line complexity
    createNewProject = (siaStore) => {
        const isEmptyProjectName = this.isNewProject && this.newProjectInput.length === 0;
        const isProjectExist = this.typeToggle === Tag.CLASSIFICATION ? false : (this.projects.find((value:string) => value.toLocaleString() === this.newProjectInput) || this.videosProjects.find((value:string) => value === this.newProjectInput));
        const isAttributesEmpty = this.typeToggle === Tag.CLASSIFICATION ? false : this.attributesArray.length === 0 && !(this.showFeatures && this.typeToggle === Tag.DEFAULT);
        const isLabelsEmpty = this.typeToggle === Tag.CLASSIFICATION ? false : this.labelsArray.length === 0 && !(this.showFeatures && this.typeToggle === Tag.DEFAULT);
        const isClassesEmpty = this.classesArray.length === 0 && !(this.showFeatures && this.typeToggle === Tag.DEFAULT);
        const isNoData = this.typeToggle === Tag.CLASSIFICATION ? this.numberOfFiles === 0 && this.isNewProject : this.numberOfFiles === 0;

        if (!textInputValidation.runValidation(this.newProjectInput, {key: 'PROJECT_NAME_REGEX'}) && this.isNewProject) {
            this.isErrorInputNewProject = true;

            return;
        }
        if (isEmptyProjectName || isNoData || isProjectExist || isAttributesEmpty || isLabelsEmpty || isClassesEmpty) {
            (isEmptyProjectName || !!isProjectExist) && (this.isErrorInputNewProject = true);
            this.isAttributeError = isAttributesEmpty;
            this.isClassError = isClassesEmpty;
            this.isLabelError = isLabelsEmpty;
            this.isUploadInputError = this.numberOfFiles === 0;
        } else if (this.typeToggle === Tag.DEFAULT) {
            storageService.removeFromStorage('refresh');
            this.startUploadingImages(siaStore, this.newProjectInput);
            this.showFeatures && this.setAutoTagging(siaStore);
        } else if (this.typeToggle === Tag.CLASSIFICATION) {
            const isClassProjectExist = this.classificationProjects ? this.classificationProjects.find((project) => project.project_name.toLocaleString() === this.newProjectInput) : false;
            const [folderExist, classExist]:any = this.checkFolders(loadService.foldersNames, this.classesArray);

            if (folderExist.isFolderExist && classExist.isClassExist && !isClassProjectExist && this.isNewProject) {
                this.isUploadMode = true;
                this.loadTitle = 'Upload Videos';
                this.sendVideosToS3(siaStore);
                this.classificationError = '';
            } else if (isClassProjectExist && this.isNewProject) {
                this.classificationError = 'Project name already exist';
            } else if (this.isNewProject) {
                this.classificationError = !folderExist.isFolderExist ? `Missing ${folderExist.folderName} in the classes`
                    : `Missing ${classExist.className} in the folders`;
            } else {
                const thisProject = this.classificationProjects && this.classificationProjects.find((project) => project.project_name === this.projectChosen);
                const filesObject = thisProject && utilService.margeArrayOfArrays(Object.values(thisProject.files)).reduce((a, v) => ({ ...a, [v]: v}), {});

                filesObject ? Object.values(loadService.videosFiles).forEach((videos:any) => filesObject[videos.name] && this.videoFilesList.push(videos.name)) : false;
                this.videoFilesList.length === 0 && this.uploadVideosToExistingProject(siaStore);
            }
        } else {
            this.isUploadMode = true;
            this.loadTitle = 'Upload Videos';
            this.sendVideosToS3(siaStore);
        }
    }

    checkIfParamsIsEmpty = () => {
        let canOpenProject = true;

        if (this.attributesArray.length === 0) {
            this.isAttributeError = true;
            canOpenProject = false;
        }
        if (this.classesArray.length === 0) {
            this.isClassError = true;
            canOpenProject = false;
        }
        if (this.labelsArray.length === 0) {
            this.isLabelError = true;
            canOpenProject = false;
        }

        return canOpenProject;
    }

    /**
     * openTaggingModeOrSegmethorMode - when user choose tagging mode or segmenthor
     * @param siaStore - siaStore singleton
     * @param taskName - the task name for websocket
     * @param reqName - reqName for the project details
     * @param isVideo - video as different path
     */
    openTaggingModeOrSegmenthorMode = (siaStore, taskName, reqName, isVideo) => {

        if (this.checkIfParamsIsEmpty()) {
            const token = storageService.loadFromStorage('token');
            const pathName = this.projectChosen;

            this.setState({isLoadData: true});
            this.getProjectDetails(token, reqName, siaStore, isVideo).then(() => this.setSiaPage(taskName, pathName, siaStore));
        }
    }

    /**
     * openHitlMode - when user open HITL mode (verification)
     * @param siaStore
     */
    openHitlMode = (siaStore) => {
        const taskName = 'add_listener_channel';
        const pathName = this.productionChosen.join(',');

        this.setSiaPage(taskName, pathName, siaStore);
    }

    /**
     * openHitlMode - when user open accuracy mode (verification)
     */
    openAccuracyMode = (siaStore) => {
        if (this.accuracyNumberOfDate === '/') {
            this.accuracyNumberOfDate = '';
        } else if (this.accuracyNumberOfImages > 0 && this.accuracyNumberOfDateNumber > 0) {
            const accuracyObj = {
                'user_name': storageService.loadFromStorage('username'),
                'project_name': this.productionChosenAccuracy,
                'feature_name': this.productionFeatureChosen,
                'date': this.accuracyNumberOfDate,
                'time_type': this.accuracyNumberOfDateRange.toLowerCase(),
                'time_num': +this.accuracyNumberOfDateNumber,
                'images_num': +this.accuracyNumberOfImages
            };
            const taskName = 'add_accuracy_user';
            const pathName = this.productionChosenAccuracy;

            if (this.accuracyGlobalData && this.accuracyGlobalData[this.productionFeatureChosen]) {
                this.colors = this.accuracyGlobalData[this.productionFeatureChosen].colors;
                siaStore.setChosenAttribute(this.accuracyGlobalData[this.productionFeatureChosen].attributes[0]);
                siaStore.setChosenLabel(this.accuracyGlobalData[this.productionFeatureChosen].labels[0]);
                siaStore.addToDefaultAttributes(this.accuracyGlobalData[this.productionFeatureChosen].attributes);
                siaStore.addToDefaultLabels(this.accuracyGlobalData[this.productionFeatureChosen].labels);
                siaStore.setColorDefault(this.accuracyGlobalData[this.productionFeatureChosen].colors);
                siaStore.setClasses(this.accuracyGlobalData[this.productionFeatureChosen].classes);
            }
            this.setSiaPage(taskName, pathName, siaStore, accuracyObj);
        }

    }

    /**
     * downLoad - when user wants to download the project
     * @param siaStore
     */
    @action downLoad = (siaStore) => {
        siaStore.setPageAfterUploadSia(this.setPageAfterUpload);
        siaStore.setProgressBarAfterUploadSia(this.setProgressBarAfterUpload);
        this.isUploadMode = true;
        this.loadTitle = 'Download Project';
        siaStore.setProjectName(this.projectChosen);
        siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore!.sendTask('download_project_zip', this.featuresTypeChosen, this.featuresNameChosen));

    }

    /**
     * findIfNeedToOpenEdit - find if need to send to server the edit project
     */
    findIfNeedToOpenEdit = () => {
        let answer = false;

        for (const key in this.editProjectParameters) {
            if (has(this.editProjectParameters, key)) {
                for (const innerKey in this.editProjectParameters[key]) {
                    if (this.editProjectParameters[key][innerKey].length > 0) {
                        answer = true;
                        break;
                    }
                }
            }

        }

        return answer;
    }

    /**
     * done - when user wants to move to main page
     */
    @action done = (siaStore) => {
        if (this.isNewProject && (this.typeToggle === Tag.DEFAULT || this.typeToggle === Tag.SEGMENTHOR)) {
            this.createNewProject(siaStore);
        } else {
            switch (this.typeToggle) {
                case Tag.DEFAULT:
                    if (this.findIfNeedToOpenEdit()) {
                        siaStore.openTaggingModeOrSegmenthorModeSia = () => this.openTaggingModeOrSegmenthorMode(siaStore, 'get_project_data', 'PROJECT_DETAILS', false);
                        if (this.checkIfParamsIsEmpty()) {
                            siaStore.setProjectName(this.projectChosen);
                            this.setState({isLoadData: true});
                            siaStore.setEditProjectParametersSia(this.editProjectParameters);
                            siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('edit_project_params'));
                        }

                    } else {
                        this.openTaggingModeOrSegmenthorMode(siaStore, 'get_project_data', 'PROJECT_DETAILS', false);
                    }
                    break;
                case Tag.LISTEN:
                    this.openHitlMode(siaStore);
                    break;
                case Tag.SEGMENTHOR:
                    if (this.frameSampling > 0) {
                        if (this.findIfNeedToOpenEdit()) {
                            siaStore.openTaggingModeOrSegmenthorModeSia = () => this.openTaggingModeOrSegmenthorMode(siaStore, 'open_video_project', 'PROJECT_DETAILS_VIDEOS', true);
                            // eslint-disable-next-line max-depth
                            if (this.checkIfParamsIsEmpty()) {
                                siaStore.setProjectName(this.projectChosen);
                                this.setState({isLoadData: true});
                                siaStore.setEditProjectParametersSia(this.editProjectParameters);
                                siaStore.ws.initConnection(this.typeToggle, siaStore.responseFromSocket, () => siaStore.sendTask('edit_project_params'));
                            }
                        } else {
                            this.openTaggingModeOrSegmenthorMode(siaStore, 'open_video_project', 'PROJECT_DETAILS_VIDEOS', true);
                        }
                    }
                    break;
                case Tag.ACCURACY:
                    this.openAccuracyMode(siaStore);
                    break;
                default :
                    break;
            }
        }
    }
}
export default new SettingsStore();
